import {
  COMPARE_PRODUCT_ERROR,
  COMPARE_PRODUCT_RECEIVE,
  SHOW_COMPARE_BUTTON_ERROR,
} from '../Actions/ComparedProduct.action';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
  list: [],
  showCompareButtonError: undefined,
  errors: {},
};

export const comparedProducts = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHOW_COMPARE_BUTTON_ERROR:
    case COMPARE_PRODUCT_RECEIVE:
      return {
        ...state,
        errors: {},
        ...payload,
      };
    case COMPARE_PRODUCT_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    default:
      return state;
  }
};
